export default __webpack_public_path__ + "static/media/play.6dbea32a.png";